<div class="modal" data-id="ad-modal" hidden>
  <div class="modal__backdrop" data-id="ad-backdrop"></div>

  <div class="modal__dialog" role="dialog" aria-modal="true" aria-labelledby="ad-title">
    <header class="modal__header">
      <h2 class="modal__title" id="ad-title"><%= _lcs( 'Unterkunft-Details' ) %></h2>
      <button type="button" class="iconbtn modal__close" data-id="ad-close" aria-label="<%= _lcs( 'Schließen' ) %>">
        <i class="icon icon--x"></i>
      </button>
    </header>

    <div class="modal__body">
      <dl class="modal__dl">
        <dt><%= _lcs( 'Name' ) %></dt><dd data-id="ad-name">—</dd>
        <dt><%= _lcs( 'Slug' ) %></dt><dd data-id="ad-slug" class="modal__dl-mono">—</dd>
        <dt><%= _lcs( 'Typ' ) %></dt><dd data-id="ad-type">—</dd>
        <dt><%= _lcs( 'Status' ) %></dt><dd data-id="ad-status">—</dd>
        <dt><%= _lcs( 'Region' ) %></dt><dd data-id="ad-region">—</dd>
        <dt><%= _lcs( 'Eigentümer' ) %></dt><dd data-id="ad-owner">—</dd>
        <dt><%= _lcs( 'Zeitzone' ) %></dt><dd data-id="ad-timezone">—</dd>
        <dt><%= _lcs( 'Webseite' ) %></dt><dd data-id="ad-www">—</dd>
        <dt><%= _lcs( 'Adresse' ) %></dt><dd data-id="ad-address">—</dd>
        <dt><%= _lcs( 'Erstellt am' ) %></dt><dd data-id="ad-created">—</dd>
        <dt><%= _lcs( 'Aktualisiert am' ) %></dt><dd data-id="ad-updated">—</dd>
        <dt>ID</dt><dd data-id="ad-id" class="modal__dl-mono">—</dd>
      </dl>
    </div>

    <footer class="modal__footer">
      <button type="button" class="btn btn--ghost btn--sm" data-id="ad-close-btn"><%= _lcs( 'Schließen' ) %></button>
    </footer>
  </div>
</div>
